import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { jjLogger } from "utils/logUtils";

const useGoogleOptimize = () => {
  const [loading, setLoading] = useState(true);
  const [testValue, setTestValue] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const getTestValue = (testName) => (queryParams.has(testName) ? queryParams.get(testName) : window.GO[testName]);

  useEffect(() => {
    jjLogger.logDebug("useGoogleOptimize.js: loading");
    jjLogger.logDebug(loading);
    jjLogger.logDebug("useGoogleOptimize.js: testValue");
    jjLogger.logDebug(testValue);
  }, [testValue]);

  const loadTest = (testName) => {
    jjLogger.logDebug("useGoogleOptimize.js: testName");
    jjLogger.logDebug(testName);

    if (window.GO) {
      setTestValue(getTestValue(testName));
      setLoading(false);
    } else {
      const waitForGO = () => {
        document.removeEventListener("GO:done", waitForGO);
        setTestValue(getTestValue(testName));
        setLoading(false);
      };
      document.addEventListener("GO:done", waitForGO);
    }
  };

  return {
    loading,
    loadTest,
    testValue,
  };
};

export default useGoogleOptimize;
